import { send } from '../../../../../../../src/network';

type DeleteCustomerPairingRatingDetailResponse = void;

export type DeleteCustomerPairingRatingDetailParams = {
  customer_id: string;
  pairing_id: number;
};

export async function deleteApiV2CustomersCustomerIdPairingRatingsPairingId(
  params: DeleteCustomerPairingRatingDetailParams
) {
  return await send<DeleteCustomerPairingRatingDetailResponse>({
    path: `/api/v2/customers/${params.customer_id}/pairing_ratings/${params.pairing_id}/`,
    method: 'DELETE',
  });
}
